import React from 'react';
import i18n from '../../i18n';
import SaleContractTextEn from './locales/SaleContractTextEn';
import SaleContractTextTr from './locales/SaleContractTextTr';

const SaleContractText = (props) => {
    return i18n.language === "en" ? <SaleContractTextEn {...props} /> : <SaleContractTextTr {...props} />
}

export default SaleContractText